import _ from "lodash";
import React from "react";
import { connect } from "react-redux";
import { compose } from "lib/apolloClient";
import classes from "./ResourceList.scss";
import ResourceImagePlaceHolder from "UIComponents/ResourceImagePlaceHolder";
import I18nHOC from "UIComponents/I18nHOC";
import Loading from "UIComponents/Loading";
import classNames from "classnames";
import { EmptyState, IconButton } from "@toddle-edu/ds-web";
import {
  NoSearchInFilterIllustration,
  LEIllustraton,
} from "@toddle-edu/ds-theme";
import { ChevronRightOutlined } from "@toddle-edu/ds-icons";
import { getCurrentAssessmentTypes } from "Platform/modules/PlatformModule";

const styles = {
  newImagePlaceholder: {
    borderRadius: "8px 0px 0px 8px",
    height: "72px",
    width: "72px",
    flex: "inherit",
  },
  imagePlaceholder: {
    height: "64px",
    width: "80px",
    flex: "inherit",
  },
};
const emptyStateSubtitleStyle = {
  lineHeight: "24px",
};

class ResourceList extends React.PureComponent {
  constructor(props) {
    super(props);
  }
  renderResources = () => {
    const {
      resources,
      resourceId,
      onItemClicked,
      t,
      searchText,
      unitPlanOptionsLength,
      selectedUnitPlan,
      curriculumProgramType,
      getCurrentAssessmentTypes,
    } = this.props;

    const currentAssessmentTypes = getCurrentAssessmentTypes();

    const getGoalsAndStudentCount = resource => {
      return _.reduce(
        _.get(resource, "fields", []),
        (acc, element) => {
          const count = _.isArray(_.get(element, "value"))
            ? _.get(element, "value.length", 0)
            : 0;
          return acc + count;
        },
        0
      );
    };

    return _.get(resources, "length", 0) > 0 &&
      _.size(selectedUnitPlan, 0) > 0 ? (
      _.map(resources, resource => {
        const assessmentType = _.get(resource, "assessmentType.value") || "le";
        const { color, localeLabel = "", label = "" } =
          currentAssessmentTypes[assessmentType] || {};
        const isSelected = resource.id === resourceId;

        const unitContainerClass = classNames({
          [classes.unitContainerSelected]: isSelected,
          [classes.unitContainer]: true,
        });
        const title = _.get(resource, "title.value")
          ? _.get(resource, "title.value")
          : "Untitled";
        const learningGoalsCount = getGoalsAndStudentCount(resource);
        return (
          <React.Fragment key={_.get(resource, "id")}>
            <div
              data-test-id={`journal-postcreation-taglearninggoals-le-item-${_.get(
                resource,
                "id"
              )}`}
              onClick={() => onItemClicked(resource)}
              className={classes.singleItemContainer}
              key={_.get(resource, "id")}
            >
              <div className={classes.itemAvatar}>
                <ResourceImagePlaceHolder
                  id={resource.id}
                  imageUrl={_.get(resource, "image.value", "")}
                  imageThumbSize={56}
                  containerStyle={styles.newImagePlaceholder}
                />
              </div>
              <div className={classes.itemDetailsContainer}>
                <div
                  data-test-id={`journal-postcreation-taglearninggoals-le-title-${title}`}
                  className={classes.resourceTitle}
                >
                  {title}
                </div>
                <div className={classes.resourceCentralIdea}>
                  {t("journal:learning_goals_count", {
                    count: learningGoalsCount,
                  })}
                </div>
              </div>
              <IconButton
                icon={<ChevronRightOutlined />}
                variant={"plain"}
                size={"medium"}
              />
            </div>
          </React.Fragment>
        );
      })
    ) : _.get(searchText, "length", 0) > 0 ||
      _.get(selectedUnitPlan, "length", 0) >= 0 ? (
      <div className={classes.noDataContainer}>
        <EmptyState
          illustration={NoSearchInFilterIllustration}
          title={t("common:noResultHeading")}
          subtitle={t("common:no_items_matching_your_search")}
          subtitleStyle={emptyStateSubtitleStyle}
          size="small"
        />
      </div>
    ) : (
      <div className={classes.noDataContainer}>
        <EmptyState
          illustration={LEIllustraton}
          title={
            curriculumProgramType == "IB_PYP"
              ? t("journal:no_le_exist_unitplan")
              : t("journal:no_le_assessment")
          }
        />
      </div>
    );
  };

  renderOrDivider = () => {
    const { t } = this.props;
    return (
      <div className={classes.orContainer}>
        <div className={classes.orContentLine} />
        <div className={classes.orText}>
          {t("common:uppercase", { text: t("common:or") })}
        </div>
        <div className={classes.orContentLine} />
      </div>
    );
  };

  getTagLEOrAssessmentText = () => {
    const { assessmentCount, t } = this.props;
    if (assessmentCount > 0) {
      return t("journal:select_elements_tag_assessment");
    }
    return t("journal:select_elements_tag_le");
  };

  render() {
    const {
      isResourceSkipped,
      onResourceSkipClicked,
      t,
      networkStatus,
    } = this.props;
    const unitContainerClass = classNames({
      [classes.unitContainerSelected]: isResourceSkipped,
      [classes.unitContainer]: true,
    });

    return (
      <div className={classes.container}>
        <div className={classes.listContent}>
          {this.renderResources()}
          {networkStatus == 3 ? (
            <Loading loadingStyle={{ width: 36, height: 36 }} />
          ) : null}
        </div>
      </div>
    );
  }
}

const mapActionCreators = {
  getCurrentAssessmentTypes,
};

export default compose(
  I18nHOC({ resource: ["journal", "common"] }),
  connect(null, mapActionCreators)
)(ResourceList);
